import * as React from "react";

import * as DTO from "../../interfaces";
import { PaginatedPlayerList } from "@/components/Lists/PaginatedPlayerList";

import "./styles.scss";

interface OwnProps {
  selectedPlayers?: number[];

  parentResource?: string;
  disabled?: boolean;
  onChange: (selectedPlayers: number[]) => void;
  onPlayersLoaded?: (players: DTO.PlayerWithBranch[]) => void;
  showNetworks?: boolean;
}

type Props = OwnProps;

const PlayerPostingFC: React.FC<Props> = ({ selectedPlayers = [], onChange, onPlayersLoaded, showNetworks = true }) => {
  const eligibilityCriteria = "include";
  React.useEffect(() => {
    onChange(selectedPlayers);
  }, [eligibilityCriteria, selectedPlayers]);

  return (
    <PaginatedPlayerList
      queryKey="subscribedPlayersByTag"
      selectedPlayers={selectedPlayers}
      onPlayersLoaded={onPlayersLoaded}
      showNetworks={showNetworks}
      onChangeSelectedPlayer={(playerIds: number[], checked: boolean) => {
        let newSelected: number[];
        if (checked) {
          newSelected = [...selectedPlayers, ...playerIds];
        } else {
          newSelected = selectedPlayers.filter(pId => {
            return !playerIds.includes(pId);
          });
        }
        onChange(newSelected);
      }}
    />
  );
};

export const PlayersPosting = PlayerPostingFC;
